import { render } from "./UcariHome.vue?vue&type=template&id=35caef93"
import script from "./UcariHome.vue?vue&type=script&lang=js"
export * from "./UcariHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__